export default [
  { code: 'ABC', name: '中国农业银行' },
  { code: 'AEON', name: 'AEON银行' },
  { code: 'ARCU', name: '安徽省农村信用社' },
  { code: 'ASCB', name: '鞍山银行' },
  { code: 'AYCB', name: '安阳银行' },
  { code: 'BANKWF', name: '潍坊银行' },
  { code: 'BCDMMA', name: '澳门商业银行' },
  { code: 'BDCBANK', name: '保定银行' },
  { code: 'BEAHK', name: '东亚银行有限公司' },
  { code: 'BGB', name: '广西北部湾银行' },
  { code: 'BHB', name: '河北银行' },
  { code: 'BJBANK', name: '北京银行' },
  { code: 'BJRCB', name: '北京农村商业银行' },
  { code: 'BNU', name: '大西洋银行' },
  { code: 'BOC', name: '中国银行' },
  { code: 'BOCD', name: '承德银行' },
  { code: 'BOCFCB', name: '中银富登村镇银行' },
  { code: 'BOCY', name: '朝阳银行' },
  { code: 'BOCZ', name: '沧州银行' },
  { code: 'BOD', name: '东莞银行' },
  { code: 'BODD', name: '丹东银行' },
  { code: 'BOHAIB', name: '渤海银行' },
  { code: 'BOHN', name: '海南省农村信用社' },
  { code: 'BOJZ', name: '锦州银行' },
  { code: 'BOL', name: '洛阳银行' },
  { code: 'BOP', name: '平顶山银行' },
  { code: 'BOQH', name: '青海银行' },
  { code: 'BOQZ', name: '泉州银行' },
  { code: 'BOSH', name: '新韩银行(中国)' },
  { code: 'BOSZ', name: '苏州银行' },
  { code: 'BOYK', name: '营口银行' },
  { code: 'BOZK', name: '周口银行' },
  { code: 'BSB', name: '包商银行' },
  { code: 'BZMD', name: '驻马店银行' },
  { code: 'CAB', name: '宝鸡商行' },
  { code: 'CABANK', name: '长安银行' },
  { code: 'CBBQS', name: '城市商业银行资金清算中心' },
  { code: 'CBKF', name: '开封市商业银行' },
  { code: 'CCB', name: '中国建设银行' },
  { code: 'CCQTGB', name: '重庆三峡银行' },
  { code: 'CDB', name: '国家开发银行' },
  { code: 'CDCB', name: '成都银行' },
  { code: 'CDRCB', name: '成都农商银行' },
  { code: 'CEB', name: '中国光大银行' },
  { code: 'CEP', name: '中银通商务支付有限公司' },
  { code: 'CGNB', name: '南充市商业银行' },
  { code: 'CHB', name: '创兴银行有限公司' },
  { code: 'CIB', name: '兴业银行' },
  { code: 'CITI', name: '花旗银行(中国)' },
  { code: 'CITIC', name: '中信银行' },
  { code: 'CJCCB', name: '苏州长江商业银行' },
  { code: 'CMB', name: '招商银行' },
  { code: 'CMBC', name: '中国民生银行' },
  { code: 'COMM', name: '交通银行' },
  { code: 'COMMHK', name: '交通银行香港分行' },
  { code: 'CQBANK', name: '重庆银行' },
  { code: 'CRCBANK', name: '重庆农村商业银行' },
  { code: 'CSC', name: 'CSC借记卡' },
  { code: 'CSCB', name: '长沙银行' },
  { code: 'CSRCB', name: '常熟农村商业银行' },
  { code: 'CYBC', name: '集友银行' },
  { code: 'CYS', name: '中国银盛' },
  { code: 'CZBANK', name: '浙商银行' },
  { code: 'CZCB', name: '浙江稠州商业银行' },
  { code: 'CZCCB', name: '长治市商业银行' },
  { code: 'CZRCB', name: '常州农村信用联社' },
  { code: 'DAQINGB', name: '龙江银行' },
  { code: 'DBS', name: '星展银行' },
  { code: 'DBSCN', name: '星展银行' },
  { code: 'DLB', name: '大连银行' },
  { code: 'DRCBCL', name: '东莞农村商业银行' },
  { code: 'DSB', name: '大新银行' },
  { code: 'DTCCB', name: '大同银行' },
  { code: 'DYCB', name: '德阳商业银行' },
  { code: 'DYCCB', name: '东营市商业银行' },
  { code: 'DZBANK', name: '德州银行' },
  { code: 'DZCBANK', name: '达州银行' },
  { code: 'EGBANK', name: '恒丰银行' },
  { code: 'ERB', name: '龙岗鼎业村镇银行' },
  { code: 'ESRCB', name: '恩施农村商业银行' },
  { code: 'FDB', name: '富滇银行' },
  { code: 'FJHXBC', name: '福建海峡银行' },
  { code: 'FJNX', name: '福建省农村信用社联合社' },
  { code: 'FMBANK', name: '吉林丰满惠民村镇银行' },
  { code: 'FSCB', name: '抚顺银行' },
  { code: 'FSCCB', name: '抚顺银行股份有限公司' },
  { code: 'FXCB', name: '阜新银行' },
  { code: 'GCB', name: '广州银行' },
  { code: 'GDB', name: '广东发展银行' },
  { code: 'GDRCC', name: '广东省农村信用社联合社' },
  { code: 'GHB', name: '广东华兴银行' },
  { code: 'GLBANK', name: '桂林银行' },
  { code: 'GRCB', name: '广州农商银行' },
  { code: 'GSBANK', name: '甘肃银行' },
  { code: 'GSRCU', name: '甘肃省农村信用' },
  { code: 'GXHMVB', name: '长春高新惠民村镇银行' },
  { code: 'GXRCU', name: '广西省农村信用' },
  { code: 'GYCB', name: '贵阳银行' },
  { code: 'GZB', name: '赣州银行' },
  { code: 'GZRCU', name: '贵州农商联合银行' },
  { code: 'H3CB', name: '内蒙古银行' },
  { code: 'HANABANK', name: '韩亚银行' },
  { code: 'HBC', name: '湖北银行' },
  { code: 'HBHSBANK', name: '湖北银行黄石分行' },
  { code: 'HBRCU', name: '河北省农村信用社' },
  { code: 'HBYCBANK', name: '湖北银行宜昌分行' },
  { code: 'HDBANK', name: '邯郸银行' },
  { code: 'HDHMCB', name: '惠东惠民村镇银行' },
  { code: 'HKB', name: '汉口银行' },
  { code: 'HKBEA', name: '东亚银行' },
  { code: 'HLDB', name: '葫芦岛市商业银行' },
  { code: 'HLDCCB', name: '葫芦岛市商业银行' },
  { code: 'HLJRCU', name: '黑龙江省农村信用社' },
  { code: 'HNRCC', name: '湖南省农村信用社' },
  { code: 'HNRCU', name: '河南省农村信用' },
  { code: 'HRBANK', name: '哈尔滨银行' },
  { code: 'HRXJB', name: '华融湘江银行' },
  { code: 'HSB', name: '恒生银行' },
  { code: 'HSBANK', name: '徽商银行' },
  { code: 'HSBC', name: '汇丰银行(中国)' },
  { code: 'HSBK', name: '衡水银行' },
  { code: 'HURCB', name: '湖北省农村信用社' },
  { code: 'HXBANK', name: '华夏银行' },
  { code: 'HZCB', name: '杭州银行' },
  { code: 'HZCCB', name: '湖州市商业银行' },
  { code: 'ICBC', name: '中国工商银行' },
  { code: 'JHBANK', name: '金华银行' },
  { code: 'JINCHB', name: '晋城银行' },
  { code: 'JJBANK', name: '九江银行' },
  { code: 'JLBANK', name: '吉林银行' },
  { code: 'JLRCU', name: '吉林农信' },
  { code: 'JNBANK', name: '济宁银行' },
  { code: 'JRCB', name: '江苏江阴农村商业银行' },
  { code: 'JSB', name: '晋商银行' },
  { code: 'JSBANK', name: '江苏银行' },
  { code: 'JSRCU', name: '江苏省农村信用联合社' },
  { code: 'JXBANK', name: '嘉兴银行' },
  { code: 'JXRCU', name: '江西省农村信用' },
  { code: 'JZBANK', name: '晋中市商业银行' },
  { code: 'JZCBANK', name: '焦作市商业银行' },
  { code: 'KLB', name: '昆仑银行' },
  { code: 'KMRCU', name: '昆明农村信用联合社' },
  { code: 'KORLABANK', name: '库尔勒市商业银行' },
  { code: 'KSRB', name: '昆山农村商业银行' },
  { code: 'KSRCB', name: '昆山农信社' },
  { code: 'LANGFB', name: '廊坊银行' },
  { code: 'LNRCC', name: '辽宁省农村信用社' },
  { code: 'LSB', name: '临商银行' },
  { code: 'LSBANK', name: '莱商银行' },
  { code: 'LSBC', name: '临商银行' },
  { code: 'LSCCB', name: '乐山市商业银行' },
  { code: 'LSZRCB', name: '凉山州商业银行' },
  { code: 'LUZBANK', name: '泸州市商业银行' },
  { code: 'LYBANK', name: '洛阳银行' },
  { code: 'LYCB', name: '辽阳市商业银行' },
  { code: 'LZCCB', name: '柳州银行' },
  { code: 'LZYH', name: '兰州银行' },
  { code: 'MTBANK', name: '浙江民泰商业银行' },
  { code: 'MYCCBANK', name: '绵阳市商业银行' },
  { code: 'MYBANK', name: '网商银行' },
  { code: 'NBBANK', name: '宁波银行' },
  { code: 'NBYZ', name: '鄞州银行' },
  { code: 'NCB', name: '南昌银行' },
  { code: 'NCBANK', name: '宁波通商银行' },
  { code: 'NDHB', name: '宁波东海银行' },
  { code: 'NHB', name: '南海农村信用联社' },
  { code: 'NHQS', name: '农信银清算中心' },
  { code: 'NJCB', name: '南京银行' },
  { code: 'NMGNXS', name: '内蒙古农村信用社' },
  { code: 'NTCCB', name: '南通商业银行' },
  { code: 'NXBANK', name: '宁夏银行' },
  { code: 'NXRCU', name: '宁夏黄河农村商业银行' },
  { code: 'NYBANK', name: '广东南粤银行' },
  { code: 'NYCB', name: '南阳村镇银行' },
  { code: 'NYNB', name: '广东南粤银行' },
  { code: 'OCBC', name: '华侨银行（中国）' },
  { code: 'ORBANK', name: '鄂尔多斯银行' },
  { code: 'PLCCB', name: '平凉市商业银行' },
  { code: 'PSBC', name: '中国邮政储蓄银行' },
  { code: 'PZBANK', name: '盘锦市商业银行' },
  { code: 'PZHCCB', name: '攀枝花市商业银行' },
  { code: 'QDCCB', name: '青岛银行' },
  { code: 'QDRCB', name: '青岛农村商业银行' },
  { code: 'QHDBANK', name: '秦皇岛银行' },
  { code: 'QHDCCB', name: '秦皇岛市商业银行' },
  { code: 'QHRC', name: '青海农村信用社' },
  { code: 'QJCCB', name: '曲靖市商业银行' },
  { code: 'QLBANK', name: '齐鲁银行' },
  { code: 'QLCZYH', name: '齐鲁村镇银行' },
  { code: 'RBOZ', name: '珠海华润银行' },
  { code: 'RXCB', name: '榆次融信村镇银行' },
  { code: 'RZB', name: '日照银行' },
  { code: 'RZCCB', name: '日照银行' },
  { code: 'SCB', name: '渣打银行' },
  { code: 'SCBHK', name: '渣打银行(香港)' },
  { code: 'SCCB', name: '三门峡银行' },
  { code: 'SCRCU', name: '四川省农村信用社' },
  { code: 'SDEB', name: '顺德农商银行' },
  { code: 'SDRCU', name: '山东省农村信用社' },
  { code: 'SHBANK', name: '上海银行' },
  { code: 'SHRCB', name: '上海农村商业银行' },
  { code: 'SJBANK', name: '盛京银行' },
  { code: 'SLH', name: '湖南农村信用社联合社' },
  { code: 'SLRCB', name: '双流诚民村镇银行' },
  { code: 'SNCCB', name: '遂宁市商业银行' },
  { code: 'SPABANK', name: '平安银行' },
  { code: 'SPDB', name: '上海浦东发展银行' },
  { code: 'SRBANK', name: '上饶银行' },
  { code: 'SRCB', name: '深圳农村商业银行' },
  { code: 'SXCB', name: '绍兴银行' },
  { code: 'SXRCCU', name: '陕西信合' },
  { code: 'SXRCU', name: '山西省农村信用社' },
  { code: 'SZSBK', name: '石嘴山银行' },
  { code: 'TACCB', name: '泰安市商业银行' },
  { code: 'TCCB', name: '天津银行' },
  { code: 'TCRCB', name: '江苏太仓农村商业银行' },
  { code: 'TFB', name: '大丰银行有限公司' },
  { code: 'TJBHB', name: '天津滨海农村商业银行' },
  { code: 'TLBANK', name: '铁岭银行' },
  { code: 'TRCB', name: '天津农商银行' },
  { code: 'TSBANK', name: '唐山银行' },
  { code: 'TZCB', name: '台州银行' },
  { code: 'URB', name: '联合村镇银行' },
  { code: 'URMQCCB', name: '乌鲁木齐市商业银行' },
  { code: 'WEBANK', name: '深圳前海微众银行' },
  { code: 'WHB', name: '永亨银行' },
  { code: 'WHBANK', name: '乌海银行' },
  { code: 'WHBMA', name: '澳门永亨银行' },
  { code: 'WHCCB', name: '威海市商业银行' },
  { code: 'WHRCB', name: '武汉农村商业银行' },
  { code: 'WJRCB', name: '吴江农商银行' },
  { code: 'WLB', name: '永隆银行' },
  { code: 'WLBHK', name: '永隆银行' },
  { code: 'WOORI', name: '友利银行(中国)' },
  { code: 'WRCB', name: '无锡农村商业银行' },
  { code: 'WXCCB', name: '无锡市商业银行' },
  { code: 'WZCB', name: '温州银行' },
  { code: 'XABANK', name: '西安银行' },
  { code: 'XWBANK', name: '四川新网银行' },
  { code: 'XCYH', name: '许昌银行' },
  { code: 'XFRCB', name: '咸丰常农商村镇银行' },
  { code: 'XHCZYH', name: '新华村镇银行' },
  { code: 'XHRCB', name: '新会农商银行' },
  { code: 'XJRCU', name: '新疆农村信用社' },
  { code: 'XLBANK', name: '中山小榄村镇银行' },
  { code: 'XMBANK', name: '厦门银行' },
  { code: 'XMCCB', name: '厦门市商业银行' },
  { code: 'XTB', name: '邢台银行' },
  { code: 'XXBANK', name: '新乡银行' },
  { code: 'XYBANK', name: '信阳银行' },
  { code: 'YACCB', name: '雅安市商业银行' },
  { code: 'YBCCB', name: '宜宾市商业银行' },
  { code: 'YCCB', name: '宜昌市商业银行' },
  { code: 'YCCCB', name: '盐城商行' },
  { code: 'YDNSCZYH', name: '尧都农商村镇银行' },
  { code: 'YDRCB', name: '尧都农商行' },
  { code: 'YKYHCCB', name: '营口沿海银行' },
  { code: 'YNRCC', name: '云南省农村信用社' },
  { code: 'YQCCB', name: '阳泉银行' },
  { code: 'YTBANK', name: '烟台银行' },
  { code: 'YXCCB', name: '玉溪市商业银行' },
  { code: 'YZBANK', name: '银座银行' },
  { code: 'ZBCB', name: '齐商银行' },
  { code: 'ZGCCB', name: '自贡市商业银行' },
  { code: 'ZHCCB', name: '珠海华润银行股份有限公司' },
  { code: 'ZJCCB', name: '镇江市商业银行' },
  { code: 'ZJKCCB', name: '张家口市商业银行' },
  { code: 'ZJNX', name: '浙江农村商业联合银行' },
  { code: 'ZJTLCB', name: '浙江泰隆商业银行' },
  { code: 'ZRCBANK', name: '张家港农村商业银行' },
  { code: 'ZYB', name: '中原银行' },
  { code: 'ZYCBANK', name: '遵义市商业银行' },
  { code: 'ZZBANK', name: '郑州银行' },
  { code: 'ZZCCB', name: '郑州商业银行' }
];
